module.exports = __webpack_public_path__ + "ba8f3b061678c55894bb4d4d15b5332e.svg";